/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateScanCheckResult {
    getFixupPrototypeFunction() { return TemplateScanCheckResult.fixupPrototype; }

    static newInstance(model: Partial<TemplateScanCheckResult>): TemplateScanCheckResult {
        let obj = Object.assign(new TemplateScanCheckResult(), model);
        TemplateScanCheckResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateScanCheckResult>): TemplateScanCheckResult {
        if (!model) return null;
        return TemplateScanCheckResult.newInstance(<TemplateScanCheckResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateScanCheckResult) {
        if (!obj) return;

        models.TemplateScanCheckResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateScanCheckResult): boolean {
        Object.setPrototypeOf(obj, TemplateScanCheckResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifier of the check, prefixed with the engine, for example terraform#CKV_AWS_20
     */
    check_id: string;

    /**
     * Human-readable name of the check
     */
    check_name: string;

    /**
     * Outcome for this check: 'passed', 'failed', 'skipped', or 'parsing_error'
     */
    status: models.TemplateScanCheckStatus;

    /**
     * The template code fragment the check evaluated
     */
    code_block: string;

    /**
     * Whether the check is 'static' (content analysis) or 'dynamic' (account-aware)
     */
    nature: models.TemplateScanCheckNature;

    /**
     * Scope the check applies to: 'global' or 'account'
     */
    scope: models.TemplateScanCheckScope;

}
